/**
 * Copyright 2022 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { Table } from '@umati/dashboard-common';
import { SectionRowElementTable } from '@umati/dashboard-types';
import SectionData from 'components/machine/sectionData';
import React, { Component } from 'react';
import TemplateHelper from 'utilities/TemplateHelper';

export interface SectionElementContentTableProps {
  element: SectionRowElementTable;
  data: any;
  label: string;
}

export interface SectionElementContentTableState {
}

export default class SectionElementContentTable extends Component<SectionElementContentTableProps, SectionElementContentTableState> {
  constructor (props : SectionElementContentTableProps) {
    super(props);
    this.state = {};
  }

  render () {
    const data: any[][] = TemplateHelper.getTableData(this.props.element, this.props.data);
    if (data.length < 1) {
      return (null);
    }
    return (
      <SectionData cols="col-12 col-sm-12 col-md-12"
        label={this.props.label}>
        <Table columnHeaders={TemplateHelper.getTableColumnHeaders(this.props.element)}
          data={data}/>
      </SectionData>
    );
  }
}
